
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as helpn3YbEVk_45aN5THD9nFMeyUgEDVwXCt2lV9kw32czFMbcMeta } from "/app/pages/help.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as usersfwkWStBj7bsR6vrbpmu_yeS56djFcxtb3JU1R98uVV4Meta } from "/app/pages/users.vue?macro=true";
import { default as verifyl1suJ3zT7AL2RaLcTuuojB_8UsVA3kw9L_gPZi3lvLwMeta } from "/app/pages/verify.vue?macro=true";
import { default as registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta } from "/app/pages/register.vue?macro=true";
import { default as departmentsaB62ug0rDZ5Iww1BVcZahjSwVp9q1vF90wFqleEc1PAMeta } from "/app/pages/departments.vue?macro=true";
import { default as organisationpBtrny5sJpjfzcs3DYydgG8F2ZWrxzBn_45vOM_45mFJhx0Meta } from "/app/pages/organisation.vue?macro=true";
import { default as resetpasswordpGI8faRxEF74NM8rmLBWHFArkewSXQHwKyA_Rn3UkDgMeta } from "/app/pages/resetpassword.vue?macro=true";
import { default as indexmAwKaAIn9PpOdLJqn_ke0SGQ2pOT2vjCsBOmQBzzNaYMeta } from "/app/pages/[domain]/index.vue?macro=true";
import { default as indexn_WYvI2HRC_DOD_YLVRJGRZIM8zGXoQfRw646f9JQXMMeta } from "/app/pages/[domain]/tasks/index.vue?macro=true";
import { default as departmenttasksadzHc7iqScxN7x_45zcOqxCTZ_45294EBTeqIY4eNDl5G5wMeta } from "/app/pages/[domain]/tasks/departmenttasks.vue?macro=true";
import { default as tasks5hM0Waup1O6xlCB_457lpC67HwpsQu_IzdeM5vquK71vkMeta } from "/app/pages/[domain]/tasks.vue?macro=true";
import { default as forgotpasswordpkq5r_45Qy0r4XUFBE6P_7x7794tbAxBCVgLQ7nOG5A1AMeta } from "/app/pages/forgotpassword.vue?macro=true";
import { default as profileB8qvvpUpOlZWWa5jSf3v36AutgQK8ujR_wlvuM3K3o0Meta } from "/app/pages/[domain]/profile.vue?macro=true";
import { default as datalO3unL5mxhN20vseF0xLkIrYKrFU6zS25awZPdbiOJoMeta } from "/app/pages/[domain]/workflows/[id]/data.vue?macro=true";
import { default as indextQSGL6l5axd0j7IN7g_ZwivHQzrAkBhxYPdpzkeajMcMeta } from "/app/pages/[domain]/workflows/[id]/index.vue?macro=true";
import { default as taskssDfkSFPYAbnkF4Eh_MriKMtEvsHhx8HFRbHgW4li9WoMeta } from "/app/pages/[domain]/workflows/[id]/tasks.vue?macro=true";
import { default as departmentsWO_45_45BxvrhUNDjBAyGA47E42s2XLutxk3lF2uEwVoO5wMeta } from "/app/pages/[domain]/workflows/[id]/departments.vue?macro=true";
import { default as _91id_93STUFmja7_JISmX9WpezRkXRH2SocscR7RueCOPSjYnYMeta } from "/app/pages/[domain]/workflows/[id].vue?macro=true";
import { default as dataoRLKWJNuy4C4lEp_EUsiPZTTz3faazziJbne_WQlmqMMeta } from "/app/pages/[domain]/blueprints/[id]/data.vue?macro=true";
import { default as index4BGC02uIhQpKPt1kSIl4t9hIoesjhyPW6zZkHnvnLM0Meta } from "/app/pages/[domain]/blueprints/[id]/index.vue?macro=true";
import { default as deptasksRdCpLnypT7T97ypY6WsZcoOIeHK9Dkf1UMN_qpDDMlIMeta } from "/app/pages/[domain]/blueprints/[id]/deptasks.vue?macro=true";
import { default as _91id_93OKsrJxdzul9EshvxKJ_45XwosRumVJi3TgtYYX5ipKXKIMeta } from "/app/pages/[domain]/blueprints/[id].vue?macro=true";
import { default as indexeSuJWIWD38IZVOfuguiOPRRq5Bam3sIXqli5xjNU9JIMeta } from "/app/pages/[domain]/workflows/index.vue?macro=true";
import { default as indexc_45wuniHDRZ19kxcH9cUa_xEdc59SDusn_45JgJKSyhYLwMeta } from "/app/pages/[domain]/blueprints/index.vue?macro=true";
import { default as _91id_93VZ310mr8MgXEGAiipWqKccy4_45YVRkJ_wgc7AM97gYsQMeta } from "/app/pages/[domain]/settings/users/[id].vue?macro=true";
import { default as indexvEvc5R9LIIPRrqrVqUrnXDAn7Qpz_45ZAPy_45n4QPS9AXUMeta } from "/app/pages/[domain]/settings/users/index.vue?macro=true";
import { default as organisationpleN8xOeUHwb0Os_45IeKXCYdCADh2GWyi5JlTahtmcf8Meta } from "/app/pages/[domain]/settings/organisation.vue?macro=true";
import { default as doneUyAyo3LI0P_A9upINNtOCYZ58eUGof5nqFS6EMAyulYMeta } from "/app/pages/[domain]/blueprints/create/done.vue?macro=true";
import { default as indexZ5KD_t_45CRu4HeUnQsMlvq51kbduNx_45K_45_452jh7qKc_9UMeta } from "/app/pages/[domain]/blueprints/create/index.vue?macro=true";
import { default as _91id_93hJbrDNRRg4tOBqCMpG62vpK35VYYBShDdz7zk2zeX9IMeta } from "/app/pages/[domain]/settings/departments/[id].vue?macro=true";
import { default as index8nOcjFPuMWAwRdE5m3GmobdxEJkFV8zuPVIsTtrwUCwMeta } from "/app/pages/[domain]/settings/departments/index.vue?macro=true";
export default [
  {
    name: "help",
    path: "/help",
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "users",
    path: "/users",
    meta: usersfwkWStBj7bsR6vrbpmu_yeS56djFcxtb3JU1R98uVV4Meta || {},
    component: () => import("/app/pages/users.vue")
  },
  {
    name: "verify",
    path: "/verify",
    component: () => import("/app/pages/verify.vue")
  },
  {
    name: "register",
    path: "/register",
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "departments",
    path: "/departments",
    meta: departmentsaB62ug0rDZ5Iww1BVcZahjSwVp9q1vF90wFqleEc1PAMeta || {},
    component: () => import("/app/pages/departments.vue")
  },
  {
    name: "organisation",
    path: "/organisation",
    meta: organisationpBtrny5sJpjfzcs3DYydgG8F2ZWrxzBn_45vOM_45mFJhx0Meta || {},
    component: () => import("/app/pages/organisation.vue")
  },
  {
    name: "resetpassword",
    path: "/resetpassword",
    component: () => import("/app/pages/resetpassword.vue")
  },
  {
    name: "domain",
    path: "/:domain()",
    meta: indexmAwKaAIn9PpOdLJqn_ke0SGQ2pOT2vjCsBOmQBzzNaYMeta || {},
    component: () => import("/app/pages/[domain]/index.vue")
  },
  {
    name: tasks5hM0Waup1O6xlCB_457lpC67HwpsQu_IzdeM5vquK71vkMeta?.name,
    path: "/:domain()/tasks",
    meta: tasks5hM0Waup1O6xlCB_457lpC67HwpsQu_IzdeM5vquK71vkMeta || {},
    component: () => import("/app/pages/[domain]/tasks.vue"),
    children: [
  {
    name: "domain-tasks",
    path: "",
    component: () => import("/app/pages/[domain]/tasks/index.vue")
  },
  {
    name: "domain-tasks-departmenttasks",
    path: "departmenttasks",
    component: () => import("/app/pages/[domain]/tasks/departmenttasks.vue")
  }
]
  },
  {
    name: "forgotpassword",
    path: "/forgotpassword",
    component: () => import("/app/pages/forgotpassword.vue")
  },
  {
    name: "domain-profile",
    path: "/:domain()/profile",
    meta: profileB8qvvpUpOlZWWa5jSf3v36AutgQK8ujR_wlvuM3K3o0Meta || {},
    component: () => import("/app/pages/[domain]/profile.vue")
  },
  {
    name: _91id_93STUFmja7_JISmX9WpezRkXRH2SocscR7RueCOPSjYnYMeta?.name,
    path: "/:domain()/workflows/:id()",
    meta: _91id_93STUFmja7_JISmX9WpezRkXRH2SocscR7RueCOPSjYnYMeta || {},
    component: () => import("/app/pages/[domain]/workflows/[id].vue"),
    children: [
  {
    name: "domain-workflows-id-data",
    path: "data",
    component: () => import("/app/pages/[domain]/workflows/[id]/data.vue")
  },
  {
    name: "domain-workflows-id",
    path: "",
    component: () => import("/app/pages/[domain]/workflows/[id]/index.vue")
  },
  {
    name: "domain-workflows-id-tasks",
    path: "tasks",
    component: () => import("/app/pages/[domain]/workflows/[id]/tasks.vue")
  },
  {
    name: "domain-workflows-id-departments",
    path: "departments",
    component: () => import("/app/pages/[domain]/workflows/[id]/departments.vue")
  }
]
  },
  {
    name: _91id_93OKsrJxdzul9EshvxKJ_45XwosRumVJi3TgtYYX5ipKXKIMeta?.name,
    path: "/:domain()/blueprints/:id()",
    meta: _91id_93OKsrJxdzul9EshvxKJ_45XwosRumVJi3TgtYYX5ipKXKIMeta || {},
    component: () => import("/app/pages/[domain]/blueprints/[id].vue"),
    children: [
  {
    name: "domain-blueprints-id-data",
    path: "data",
    component: () => import("/app/pages/[domain]/blueprints/[id]/data.vue")
  },
  {
    name: "domain-blueprints-id",
    path: "",
    component: () => import("/app/pages/[domain]/blueprints/[id]/index.vue")
  },
  {
    name: "domain-blueprints-id-deptasks",
    path: "deptasks",
    component: () => import("/app/pages/[domain]/blueprints/[id]/deptasks.vue")
  }
]
  },
  {
    name: "domain-workflows",
    path: "/:domain()/workflows",
    meta: indexeSuJWIWD38IZVOfuguiOPRRq5Bam3sIXqli5xjNU9JIMeta || {},
    component: () => import("/app/pages/[domain]/workflows/index.vue")
  },
  {
    name: "domain-blueprints",
    path: "/:domain()/blueprints",
    meta: indexc_45wuniHDRZ19kxcH9cUa_xEdc59SDusn_45JgJKSyhYLwMeta || {},
    component: () => import("/app/pages/[domain]/blueprints/index.vue")
  },
  {
    name: "domain-settings-users-id",
    path: "/:domain()/settings/users/:id()",
    meta: _91id_93VZ310mr8MgXEGAiipWqKccy4_45YVRkJ_wgc7AM97gYsQMeta || {},
    component: () => import("/app/pages/[domain]/settings/users/[id].vue")
  },
  {
    name: "domain-settings-users",
    path: "/:domain()/settings/users",
    meta: indexvEvc5R9LIIPRrqrVqUrnXDAn7Qpz_45ZAPy_45n4QPS9AXUMeta || {},
    component: () => import("/app/pages/[domain]/settings/users/index.vue")
  },
  {
    name: "domain-settings-organisation",
    path: "/:domain()/settings/organisation",
    meta: organisationpleN8xOeUHwb0Os_45IeKXCYdCADh2GWyi5JlTahtmcf8Meta || {},
    component: () => import("/app/pages/[domain]/settings/organisation.vue")
  },
  {
    name: "domain-blueprints-create-done",
    path: "/:domain()/blueprints/create/done",
    meta: doneUyAyo3LI0P_A9upINNtOCYZ58eUGof5nqFS6EMAyulYMeta || {},
    component: () => import("/app/pages/[domain]/blueprints/create/done.vue")
  },
  {
    name: "domain-blueprints-create",
    path: "/:domain()/blueprints/create",
    meta: indexZ5KD_t_45CRu4HeUnQsMlvq51kbduNx_45K_45_452jh7qKc_9UMeta || {},
    component: () => import("/app/pages/[domain]/blueprints/create/index.vue")
  },
  {
    name: "domain-settings-departments-id",
    path: "/:domain()/settings/departments/:id()",
    meta: _91id_93hJbrDNRRg4tOBqCMpG62vpK35VYYBShDdz7zk2zeX9IMeta || {},
    component: () => import("/app/pages/[domain]/settings/departments/[id].vue")
  },
  {
    name: "domain-settings-departments",
    path: "/:domain()/settings/departments",
    meta: index8nOcjFPuMWAwRdE5m3GmobdxEJkFV8zuPVIsTtrwUCwMeta || {},
    component: () => import("/app/pages/[domain]/settings/departments/index.vue")
  }
]